import { envConfig } from "@env/env-config";

/**
 * @deprecated
 */
export const PartnerRestServiceConfig: Array<qpmn.common.rest.IServiceConfig> = [
    {
        service: "partnerRestService",
        funcName: "sendmail",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "/api/v2/partnerMails",
            isAuth: true
        }

    },
    {
        service: "partnerRestService",
        funcName: "verify",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/partnerVerifyMail",
            paramDefaults: {
                token: "@token"
            },
            isAuth: false
        },
    },
    {
        service: "partnerRestService",
        funcName: "partnerInfo",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/api/partnerInfo",
            isAuth: true
        }
    },
    {
        service: "partnerRestService",
        funcName: "eshopperInfo",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/api/shopOwnerInfo",

        }

    },
    {
        service: "partnerRestService",
        funcName: "updateEShopperInfo",
        config: {
            method: "put",
            appPath: envConfig.apps.base,
            path: "/api/shopOwnerInfo"
        }
    }
]